import { FC } from 'react';
import { RouterConfig } from '@edikk-edikk/shared';
import { CityType } from '@edikk-edikk/country-frontend';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';

type PropsType = {
  city: CityType;
};

const PopularCity: FC<PropsType> = ({
  city,
}) => {
  const routeConfig = RouterConfig.initForCity(city.id);

  return (
    <Button
      variant={ButtonVariant.outlineWhite}
      pill
      navLinkProps={{
        to: city.url,
        state: { routerConfig: routeConfig.getData() },
        end: true,
      }}
    >
      {city.title}
    </Button>
  );
};

export { PopularCity };
